import request from '@/request'

/* 得到门诊信息 */
export const getBaseInfo = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getBaseInfo.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getUserCert = data => {
  return request({
    url: '/inf_Psychologis/getUserCert.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const queryClinic = data => {
  return request({
    url: '/inf_Clinc_Vipwd/queryClinic.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const queryClinicByAccountid = data => {
  return request({
    url: '/inf_Clinc_Vipwd/queryClinicByAccountid.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

export const getUserQueryMainList = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getUserQueryMainList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

export const getUserQueryDetailList = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getUserQueryDetailList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const pumpClinic = data => {
  return request({
    url: '/inf_Clinc_Vipwd/pumpClinic.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const replyClinic = data => {
  return request({
    url: '/inf_Clinc_Vipwd/replyClinic.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getDealCount = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getDealCount.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const deleteQuery = data => {
  return request({
    url: '/inf_Clinc_Vipwd/deleteQuery.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 医生列表接口
export const getdoctorlist = data => {
  return request({
    url: '/inf_Psychologis/list.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const addQuestion = data => {
  return request({
    url: '/exterior_intFtuMentalQuestioninfo/addQuestion.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 用户查询
export const accountDatadrid = data => {
  return request({
    url: '/exterior_intFtuMentalQuestioninfo/accountDatadrid.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 医生查询
export const doctorDatadrid = data => {
  return request({
    url: '/exterior_intFtuMentalQuestioninfo/doctorDatadrid.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 查询某个问题下的对话内容
export const datadrid = data => {
  return request({
    url: '/exterior_intFtuMentalDialogueinfo/datadrid.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 用户追问
export const accountDialogue = data => {
  return request({
    url: '/exterior_intFtuMentalDialogueinfo/accountDialogue.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 医生回复
export const doctorDialogue = data => {
  return request({
    url: '/exterior_intFtuMentalDialogueinfo/doctorDialogue.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 医生删除
export const doctorDelete = data => {
  return request({
    url: 'exterior_intFtuMentalQuestioninfo/doctorDelete.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
